export const ID59 = () => {
    return (
        <div>
            <div className="content" readonly=""><h2>1С:ИТС Казахстан – единый договор для получения сервисов
                пользователями
                "1С:Предприятие"</h2>

                <img src="https://cybernetica.kz/uploads/gallery/190625086.png" width="300px" height="150px"
                     alt="1С ИТС logo" />

                <div>
                    Информационно-технологическое сопровождение (1С:ИТС Казахстан) – это комплексная поддержка,
                    которую фирма "1С" совместно с партнерами оказывает
                    пользователям программ "1С:Предприятие".
                </div>

                <div>
                    Поддержка осуществляется по договору сопровождения 1С:ИТС Казахстан ТЕХНО и ПРОФ. Тип этого
                    договора определяет объем сервисов, которые получает
                    пользователь, а также перечень доступных разделов информационной системы 1С:ИТС Казахстан.
                    Подробнее о том, что входит в состав 1С:ИТС Казахстан узнайте у
                    менеджера по телефону. Наиболее удобным для пользователей является обслуживание по договору
                    1С:ИТС Казахстан уровня ПРОФ.
                </div>

                <strong>Заключая договор 1С:ИТС Казахстан ПРОФ, каждый пользователь программ 1С получит:</strong>
                <ul>
                    <li>уверенность в легальности полученных обновлений программных продуктов фирмы "1С";</li>
                    <li>
                        возможность использовать все знания и опыт, накопленные методистами и экспертами фирмы "1С"
                        в области бухгалтерского учета, налогообложения, кадрового
                        учета;
                    </li>
                    <li>
                        материалы по эффективной работе в программах 1С с максимальным использованием мощного
                        функционала, заложенного разработчиками в систему
                        "1С:Предприятие";
                    </li>
                    <li>информацию об изменениях законодательства и их отражении в программах 1С;</li>
                    <li>персональные консультации у ведущих экспертов, аудиторов, методистов и разработчиков фирмы
                        "1С" и партнеров;
                    </li>
                    <li>квалифицированную помощь партнеров фирмы "1С" по установке, обновлению программ и
                        подключению всех информационных ресурсов фирмы "1С";
                    </li>
                    <li>
                        доступ к записям лекций, проведенных методистами 1С и приглашенными специалистами в
                        "1С:Лектории", а также возможность принимать участие в вебинарах
                        лично;
                    </li>
                    <li>безопасный и надежный доступ к офисным приложениям на платформе "1С:Предприятие" из любой
                        точки мира;
                    </li>
                    <li>возможность мгновенно обращаться к нужному специалисту обслуживающей компании для получения
                        технической поддержки, консультаций и обучения;
                    </li>
                    <li>возможность защищать базы данных 1С от непредвиденных ситуаций на удаленных серверах в
                        "облачном" хранилище.
                    </li>
                </ul>

                <h3>Цены и условия договора</h3>
                <div>
                    Важной особенностью комплексного информационно-технологического сопровождения по договору 1С:ИТС
                    Казахстан является то, что стоимость такого договора
                    значительно ниже, чем стоимость каждого предоставляемого в его рамках сервиса. Сопровождение в
                    течение льготного периода входит в стоимость программного
                    продукта.
                </div>

                <table border="2" cellPadding="1" cellSpacing="1" >
                    <tbody>
                    <tr>
                        <th>
                            &nbsp;
                            <span><span><b>Наименование услуг,&nbsp;сервисов</b></span></span><span><span><b><br/> </b></span></span>
                        </th>
                        <th>
                            <b><span>ИТС&nbsp;</span></b><b><span>Техно</span></b><b><span>&nbsp;
                            <br/> </span></b><b><span><br/> </span></b>
                            <div></div>
                            <span> </span>
                            <hr/>
                            <div>
                    <span><b><span>64 000 тг.</span><br/>
                            <span> в год</span><br/> </b></span>
                            </div>
                            <span> </span>
                        </th>

                        <th>
                            <b><span>ИТС</span></b><b><span>&nbsp;ПРОФ стандартный</span></b><b><span><br/> </span></b>
                            <div></div>
                            <span> </span>
                            <hr/>
                            <div>
                                <b><span><span>130 000 тг.</span><br/>
                            <span> в год</span><br/> </span></b>
                            </div>
                        </th>
                    </tr>
                    <tr>
                        <td>
                            <span><b><span>ОБНОВЛЕНИЕ БАЗЫ ДАННЫХ И ПЛА</span></b></span><b><span>ТФ</span></b><b><span>ОРМЫ</span></b>
                            <ul>
                                <li>ОБНОВЛЕНИЕ типовых программ 1С (дистанционно)</li>
                            </ul>
                        </td>
                        <td >
                            <h1>-<br/></h1>
                            <div>только доступ к обновлениям на сайте 1с.ru&nbsp;</div>
                        </td>

                        <td >
                            <span>до 2-х</span>
                        </td>
                    </tr>
                    <tr>
                        <td colSpan="1">
                            <span><b>ДОСТУП 1С:ИТС Казахстан</b></span> <br/>
                            для получения обновлений и методических материалов на сайтах portal.1c.ru и its.1c.kz
                        </td>
                        <td colSpan="1" >
                            <h1>+&nbsp;</h1>
                        </td>

                        <td colSpan="1" >
                            <h1>+&nbsp;</h1>
                        </td>
                    </tr>
                    <tr>
                        <td colSpan="1">
                            <span><b>1С-КОННЕКТ</b></span> – установка и подключение <br/>
                            Мессенджер для оперативной связи с поддержкой ВЦ Интеграция
                        </td>
                        <td colSpan="1" >1 пользователь</td>

                        <td colSpan="1" >3 пользователя</td>
                    </tr>
                    <tr>
                        <td colSpan="1">
                            <span><b>ЛИНИЯ КОНСУЛЬТАЦИИ Фирмы "1С"</b></span> по телефону или электронной почте <br/>
                            Специальный многоканальный: +7 (7172) 27-30-61 <br/>
                            E-mail: <a href="mailto:hotline@1c.kz">hotline@1c.kz</a>&nbsp;
                        </td>
                        <td colSpan="1" >
                            <b>в ограниченном объеме<br/> </b>одна консультация в месяц по работе с типовой
                            конфигурацией&nbsp;
                        </td>

                        <td colSpan="1">
                            <h1 >+</h1>
                        </td>
                    </tr>
                    <tr>
                        <td colSpan="1">
                            <span><b><span>СЕРВИСЫ ФИРМЫ 1С:</span></b></span><br/>
                            <ul>
                                <li>Консультации на портале 1С "Задать вопрос аудитору", "Задать вопрос по кадровому
                                    учету";
                                </li>
                                <li>
                                    1C:Лекторий - онлайн семинары с методистами фирмы 1С, ознакомление с
                                    законодательными новшествами и их отражением в 1С, получение
                                    ответов на вопросы;<br/>
                                </li>
                                <li>"1С:Линк"- подключение удалённого доступа к базе 1С;<br/></li>
                                <li>"1С:Облачный архив" - "облачная" защита баз данных пользователей 1С от
                                    непредвиденных ситуаций.<br/></li>
                            </ul>
                        </td>
                        <td colSpan="1">
                            <h1 ></h1>
                            <h1 >-</h1>
                        </td>

                        <td colSpan="1">
                            <h1 >+&nbsp;</h1>
                        </td>
                    </tr>
                    <tr>
                        <td colSpan="1">
                            <span><b><span>СЕРВИС 1С:ЭСФ</span></b></span><br/>
                            <ul>
                                <li>прямой обмен ЭСФ, ЭАВР, СНТ с государственным порталом ИС ЭСФ.<br/></li>
                            </ul>
                        </td>
                        <td colSpan="1" >
                            <div>
                                1 <br/>
                                организация
                            </div>
                        </td>

                        <td colSpan="1">
                            <div>до 10 организаций</div>
                        </td>
                    </tr>
                    <tr>
                        <td colSpan="1">
                            <div><b><br/></b></div>
                        </td>
                        <td colSpan="1">
                            <h1 ><br/></h1>
                        </td>

                        <td colSpan="1"
                            >&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;</td>
                    </tr>
                    <tr>
                        <td colSpan="1">
                            <span><b>ДОСТУП К СЕРВИСУ ДЛЯ БУХГАЛТЕРА В 1С </b></span><a
                            href="WWW.BUH-SERVICE.KZ"><span><b>WWW.BUH-SERVICE.KZ</b></span></a><span><b> :</b></span><br/>
                            <br/>
                            <b>Статистические отчеты:</b><br/>
                            <ul>
                                <li>1-ТС. Импорт и экспорт в ЕАЭС. Выгрузка в Excel;</li>
                                <li>2-МП Квартальная (заполняется малым бизнесом).<br/></li>
                            </ul>
                            <b>Отчеты по денежным средствам:</b><br/>
                            <ul>
                                <li>Расшифровка отчета движение денежных средств МСФО.</li>
                            </ul>
                            <b>Отчеты и обработки по взаиморасчетам с контрагентами:</b><br/>
                            <ul>
                                <li>Отчет по дебиторской и кредиторской задолженности;</li>
                                <li>Исправление зависших остатков по задолженности и авансам.<br/></li>
                            </ul>
                            <b>Отчеты и обработки по Счетам-фактурам и ЭСФ:</b><br/>
                            <ul>
                                <li>Обработка и заполнение входящих ЭСФ;</li>
                                <li>Обработка Счетов-фактур с отложенным зачетом НДС;<br/></li>
                                <li>Обработка и заполнение дополнительных входящих ЭСФ;<br/></li>
                                <li>Обработка и заполнение входящих ЭСФ, связка с ЭДВС и СНТ;&nbsp;<br/></li>
                                <li>Создание исходящих ЭСФ по Счетам-фактурам и накладным.<br/></li>
                            </ul>
                            <b>Кадровые отчеты по сотрудникам:</b><br/>
                            <ul>
                                <li>Отчет по остаткам отпусков сотрудников.</li>
                            </ul>
                            <b>Отчеты и обработки по ТМЗ, Услугам, ОС и НМА:</b><br/>
                            <ul>
                                <li>Проверка остатков ТМЗ по периодам;</li>
                                <li>Регистр по приобретенным товарам, услугам, РБП, ОС и НМА;<br/></li>
                                <li>Анализ товарных остатков в регистре Товары организаций (БУ) на дату.<br/>
                                </li>
                            </ul>
                            <b>Отчеты по НДС, СФ, ЭСФ:</b><br/>
                            <ul>
                                <li>Проверка входящих ЭСФ. Подвязка со счетами-фактурами и документами
                                    поступлений и возвратов;
                                </li>
                                <li>Проверка входящих Накладных. Подвязка со счетами-фактурами и ЭСФ;<br/></li>
                                <li>Проверка оборотов в регистрах НДС в целях формы 300.00;<br/></li>
                                <li>Проверка исходящих ЭСФ. Подвязка со счетами-фактурами и документами
                                    реализаций и возвратов;<br/></li>
                                <li>Проверка документов реализации. Подвязка со счетами-фактурами и ЭСФ.<br/>
                                </li>
                            </ul>
                        </td>
                        <td colSpan="1" >
                            20 000 тг./первая база данных <br/>
                            <br/>
                            10 000 тг./ дополнительная база
                        </td>

                        <td colSpan="1" >
                            <b>2 базы</b><br/>
                            <br/>
                            10 000 тг./дополнительная<br/>
                            база<br/>
                        </td>
                    </tr>
                    <tr>
                        <td colSpan="1">
                            <span><b>ЕДИНОВРЕМЕННАЯ НАСТРОЙКА АВТОМАТИЧЕСКОЙ АРХИВАЦИИ ФАЙЛОВЫХ БАЗ 1С</b></span>
                            <br/>
                            Создание архивной копии на ПК пользователя или съемный носитель
                        </td>
                        <td colSpan="2">
                            <div>
                                <span>10&nbsp;000 тг./1 база данных</span>
                            </div>
                        </td>
                    </tr>
                    <tr></tr>
                    <tr>
                        <td>
                            <b><span>ПЕРСОНАЛЬНОЕ ОБСЛУЖИВАНИЕ:&nbsp;</span></b>
                            <ul>
                                <li>
                                    <u><span>Выполнение регламентных работ ежемесячно.</span></u>
                                </li>
                            </ul>
                            <span> </span>
                            <ul>
                                <li><u>Высокий приоритет в обслуживании.</u></li>
                            </ul>
                            <span> </span>
                            <ul>
                                <li>
                                    <u><span>Разработка индивидуальных потребностей компании в 1С.</span></u>
                                </li>
                            </ul>
                            <span> </span>
                            <ul>
                                <li>
                                    <u><span>Контроль и оптимизация скорости работы 1С.</span></u>
                                </li>
                            </ul>
                        </td>
                        <td >
                            <span>-</span>
                        </td>

                        <td >
                            <h1>-</h1>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    )
}